<template>
    <div class="panel">
        <div class="panel__header">
            <h2>
                <i class="panel__header__icon icons icon-docs"></i>
                <span>{{$t('dashboard.documents.title')}}</span>
            </h2>
            <div @click.prevent="showDocumentUploadModal" class="panel_header__action">
                <i class="panel_header__action__icon icons icon-plus"></i>
                <a class="button--link hidden-xs">{{$t('dashboard.documents.add_new')}}</a>
            </div>
        </div>
        <div class="panel__body">
            <filter-chips :categories="types" @selected="onTypeFilter" />
            <documents-table />
        </div>
        <document-upload-modal />
        <document-versions-modal />
        <returned-documents-modal />
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';
    import DocumentsTable from '@/components/tables/dashboard/DocumentsTable';
    import DocumentUploadModal from '@/components/modals/dashboard/DocumentUploadModal';
    import DocumentVersionsModal from '@/components/modals/dashboard/DocumentVersionsModal';
    import ReturnedDocumentsModal from '@/components/modals/dashboard/ReturnedDocumentsModal';
    import FilterChips from '@/components/general/FilterChips';

    import { GET_DOCUMENTS } from '@/store/modules/documents';
    import { LOAD_FILE_RESOURCES } from '@/store/modules/file-resources';

    @Component({
        components: {
            DocumentVersionsModal,
            DocumentsTable,
            DocumentUploadModal,
            ReturnedDocumentsModal,
            FilterChips,
        }
    })
    export default class DocumentsPanel extends Vue {
        name = 'documents-panel';

        created() {
            this.$store.dispatch(LOAD_FILE_RESOURCES);
        }

        get actions() {
            return this.$store.state.file_resources.file_actions;
        }

        get types() {
            return this.$store.state.file_resources.file_types;
        }

        onTypeFilter(type) {
            this.$store.dispatch(GET_DOCUMENTS, { params: { trajectory_file_type: type ? type.code : null }});
        }

        showDocumentUploadModal() {
            this.$modal.show('document-upload-modal');
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/panels/dashboard/DocumentsPanel.vue